module.exports = __webpack_public_path__ + "images/application/i-ac-sign-fff14f39.svg";